import styled from "styled-components";

export const LogoContainer = styled.a`
  display: flex;
  cursor: pointer;
  padding-left: 10%;
  padding-top: 25px;
  @media (max-width: 768px) {
    padding-top: 10px;
    padding-left: 5.5%;
  }
`;

export const Logo = styled.img`
  height: 80px;
  transition: height 0.2s ease;
  @media (max-width: 768px) {
    height: 32px;
  }
`;

export const NavMenuContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  z-index: 2;
  transition: 0.3s;
`;

export const NavMenu = styled.div`
  padding: 5px;
  display: flex;
  padding-top: 68px;
  position: relative;
  transition: 0.3s;
  @media (max-width: 768px) {
    display: none;
  }
`;
export const Wrapper = styled.div`
  height: fit-content;
  min-height: 25px;
`;

export const MenuItem = styled.a`
  padding: 0 18px;
  color: #fafbff;
  font-weight: 500;
  font-size: 1.34rem;
  text-transform: uppercase;
  cursor: pointer;
  position: relative;
  display: inline-block;
  height: 25px;
  text-decoration: none;
  transition: 0.3s;
`;

export const SubMenu = styled.div`
  padding: 5px 25px 5px 0;
  max-width: 20px;
  text-transform: initial;
  overflow: visible;
  display: none;
  &.active {
    display: block;
  }
  &.last {
    display: flex;
    align-self: flex-end;
    direction: rtl;
  }
  ul {
    z-index: 6;
    list-style: none;
    padding-left: 30px;
    padding-right: 0;
  }
`;

export const SubMenuItem = styled.a`
  color: #0043ff;
  font-size: 1.24rem;
  line-height: 1.6rem;
  padding: 8px 0;
  cursor: pointer;
  display: inline-block;
  width: 220px;
  &.active,
  :hover {
    font-weight: 500;
  }
`;

export const MenuBtn = styled.a`
  cursor: pointer;
  transition: padding 0.2s ease;
  display: flex;
  align-items: center;
  padding: 55px;
  background: #fafbff;
  z-index: 999;
  position: relative;
  img {
    height: 40px;
  }
  @media (max-width: 768px) {
    padding: 16px;
    img {
      height: 20px;
    }
  }
`;

/* Reserves the navbar's height while it is fixed, so the hero does not
   jump up the moment the bar detaches from the flow. */
export const NavbarSpacer = styled.div`
  height: ${(props) => props.height}px;
`;

export const NavbarWrapper = styled.div`
  display: flex;
  justify-content: space-between;

  /* Pinned once the page has scrolled past the bar's own height. */
  &.stuck {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 100;
    background: #0043ff;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.18);
    animation: navbar-drop 0.25s ease-out;

    /* Pinned to the top of the bar, so the logo and the menu button stay put
       when the hover panel opens below the row. */
    ${LogoContainer} {
      align-self: flex-start;
      align-items: flex-start;
      padding-top: 13px;
      padding-bottom: 13px;
    }

    ${MenuBtn} {
      align-self: flex-start;
    }

    ${Logo} {
      height: 38px;
    }

    ${NavMenu} {
      padding-top: 20px;
      padding-bottom: 20px;
    }

    /* 55px of padding here is what kept the pinned bar 150px tall. */
    ${MenuBtn} {
      padding: 16px 28px;

      img {
        height: 26px;
      }
    }

    @media (max-width: 768px) {
      ${Logo} {
        height: 28px;
      }

      ${MenuBtn} {
        padding: 12px 16px;

        img {
          height: 20px;
        }
      }
    }
  }

  @keyframes navbar-drop {
    from {
      transform: translateY(-100%);
    }
    to {
      transform: translateY(0);
    }
  }

  @media (prefers-reduced-motion: reduce) {
    &.stuck {
      animation: none;
    }
  }
  &.hovered {
    ${NavMenuContainer} {
      background: #fff;
      height: fit-content;
      min-height: 150px;
    }
    ${NavMenu} {
      :before {
        content: "";
        display: block;
        background: #d7e2ff;
        height: 3px;
        width: calc(100% - 44px);
        position: absolute;
        left: 22px;
        top: 90px;
      }
    }
    ${MenuItem} {
      color: #0043ff;
      :hover:after,
      &.active:after {
        content: "";
        display: block;
        background: #0043ff;
        height: 3px;
        width: calc(100% - 34px);
        position: absolute;
        left: 17px;
        top: 22px;
      }
    }
  }
  /* The hover panel was sized for the tall header (150px, divider at 90px);
     on the compact bar it only grows as far as the submenu needs, and the
     divider sits under the shorter row (20px padding + 22px underline). */
  &.stuck.hovered {
    background: #fff;
    ${NavMenuContainer} {
      min-height: 0;
    }
    ${NavMenu} {
      :before {
        top: 42px;
      }
    }
  }
  max-height: 150px;
  overflow: visible;
`;
